import React, { useState, useEffect } from 'react';
import Dialog from '../components/Dialog';
import defaultClasses from './configuratorShare.module.css';
import { useStyle } from '../lib/util/classify';
// see all icons here: https://feathericons.com/
import { Upload as UploadIcon } from 'react-feather';
import { string, shape, number } from 'prop-types';
import SavedConfigurators from './savedConfigurators';
import { Link } from 'react-router-dom';
import ShareByEmail from './ShareIcons/ShareByEmail';
import ShareNative from './ShareIcons/ShareNative';
import SaveConfiguration from './ShareIcons/SaveConfiguration';
import { useConfiguratorShare } from '../talons/ProductConfigurator/useConfiguratorShare';
import ModalLogin from '../components/ModalLogin';

const ConfiguratorShare = props => {
    const { product, deepLink, isSignedIn, wishlists } = useConfiguratorShare(
        props
    );

    const classes = useStyle(defaultClasses, props.classes);

    const [isLoadConfigOpen, setIsLoadConfigOpen] = useState(false);

    const handleLoadConfigButtonClick = e => {
        e.preventDefault();

        if (isSignedIn) {
            setIsLoadConfigOpen(true);
        } else {
            setIsLoginOpen(true);
        }
    };

    const [isLoginOpen, setIsLoginOpen] = useState(false);

    return (
        <>
            <div className={classes.root}>
                {/* <ShareByEmail
                classes={classes}
                item={{ ...product }}
                url={deepLink}
            />

            <ShareNative
                classes={classes}
                item={{ ...product }}
                url={deepLink}
            /> */}

                <button
                    onClick={handleLoadConfigButtonClick}
                    className={classes.button}
                >
                    <UploadIcon className={classes.icon} />
                    {_('Load')}
                </button>

                <SaveConfiguration classes={classes} product={product} />

                {isLoadConfigOpen && (
                    <Dialog
                        isOpen={isLoadConfigOpen}
                        onConfirm={() => setIsLoadConfigOpen(false)}
                        onCancel={() => setIsLoadConfigOpen(false)}
                        showCancelButton={false}
                        confirmText={_('Close')}
                        title={
                            <>
                                {_('Load saved configurators')}
                                <Link to={'/customer/wishlist'}>
                                    {_('Advanced view')}
                                </Link>
                            </>
                        }
                    >
                        <SavedConfigurators wishlists={wishlists} />
                    </Dialog>
                )}
            </div>
            <ModalLogin isOpen={isLoginOpen} setIsOpen={setIsLoginOpen} />
        </>
    );
};

ConfiguratorShare.propTypes = {
    product: shape({
        sku: string,
        name: string,
        customPrice: number,
        customOptionId: number,
        customOptionValue: string
    }),
    url: string,
    clases: shape({
        root: string,
        icon: string,
        button: string
    })
};

export default ConfiguratorShare;
